import React from "react";
import "./Requirements.css";
import { Trans, useTranslation } from "react-i18next";
const FedexRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      <Trans
        t={t}
        i18nKey="carriers.custom.requirements.fedex"
        components={{
          site: (
            <a
              href={`https://developer.fedex.com/api/en-us/home.html`}
              target="_blank"
              className="email_space"
            >
              https://developer.fedex.com/api/en-us/home.html
            </a>
          ),
        }}
      />
    </div>
  );
};

export default FedexRequirements;
